import { render, staticRenderFns } from "./SamMultiChipInput.vue?vue&type=template&id=949162ba&scoped=true&"
import script from "./SamMultiChipInput.vue?vue&type=script&lang=js&"
export * from "./SamMultiChipInput.vue?vue&type=script&lang=js&"
import style0 from "./SamMultiChipInput.vue?vue&type=style&index=0&id=949162ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949162ba",
  null
  
)

export default component.exports